module.exports = __webpack_public_path__ + "media/images/redesign-images/corporate/space-2-large-019352260b219e8ef5330f5bdde9596d.jpg";